import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <section className="bg-mist px-5 py-16 md:py-24" aria-labelledby="testimonials-title" data-id="element-309" data-mp="3mgahwr509ut0">
      <div className="mx-auto max-w-6xl" data-id="element-310" data-mp="3r80tf0foiom0">
        <p className="text-center font-display text-xs font-extrabold uppercase tracking-[0.14em] text-pulse sm:text-sm" data-id="element-311" data-mp="3r93hl0lmacy8">
          Reader feedback
        </p>
        <h2 id="testimonials-title" className="mx-auto mt-3 max-w-3xl text-center font-display text-3xl font-black leading-tight text-navy-900 sm:text-5xl text-balance" data-id="element-312" data-mp="429teiyd5bm3">
          What Nursing Professionals Value About This Collection
        </h2>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-313" data-mp="2at91spqcxldr">
          {testimonials.map((t, index) => <figure key={t.name} className={`flex flex-col rounded-3xl bg-white p-6 shadow-[0_20px_40px_-30px_rgba(6,18,42,0.5)] ring-1 ring-black/5 sm:p-7 ${index === 0 ? 'lg:col-span-2' : ''}`} data-id="element-314" data-mp="2fru20p5m0527" data-mpi={index}>
              <div className="flex items-center justify-between" data-id="element-315" data-mp="1nrzsvluiagjb">
                <div className="flex gap-0.5 text-gold-600" aria-label="5 out of 5 stars" data-id="element-316" data-mp="1iv98imbo4ys3">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-317" data-mp="2bjx2d6ahgwh9" data-mpi={i} />)}
                </div>
                <QuoteIcon className="h-8 w-8 text-pulse/20" aria-hidden="true" data-id="element-318" data-mp="26llqyr4jidwx" />
              </div>
              <blockquote className={`mt-4 leading-relaxed text-ink ${index === 0 ? 'text-xl font-semibold sm:text-2xl' : 'text-[16px]'}`} data-id="element-319" data-mp="22he3ex9tj40a">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-320" data-mp="r1h0g555ajk2">
                <img src={t.image} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-pulse/20" loading="lazy" data-id="element-321" data-mp="m2vz22e5ptu1" />
                <div data-id="element-322" data-mp="sicwigi9v96j">
                  <p className="font-bold text-navy-900" data-id="element-323" data-mp="el7s0ky7iide">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-324" data-mp="en0v5q9m2kgn">{t.perspective}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center text-xs text-muted" data-id="element-325" data-mp="4ucxktat4cgv">
          Illustrative testimonials. Replace with genuine, authorized customer feedback before publication.
        </p>

        <SectionCTA label="I want to explore the ECG Interpretation Blueprint™" data-id="element-326" data-mp="3r3nuwl6fwmk9" />
      </div>
    </section>;
}